import { Calendar, CalendarClock, CalendarCheck, CheckCircle2 } from "lucide-react";

export default function BookingStats({ stats }) {
  const cards = [
    { label: "Total Bookings", value: stats.totalBookings, icon: Calendar, bg: "bg-indigo-50", color: "text-indigo-600" },
    { label: "Upcoming", value: stats.upcoming, icon: CalendarClock, bg: "bg-cyan-50", color: "text-cyan-600" },
    { label: "Today", value: stats.today, icon: CalendarCheck, bg: "bg-green-50", color: "text-green-600" },
    { label: "Completed", value: stats.completed, icon: CheckCircle2, bg: "bg-gray-100", color: "text-gray-500" },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
      {cards.map(({ label, value, icon: Icon, bg, color }) => (
        <div key={label} className="bg-white border border-gray-100 rounded-2xl p-5 flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500 mb-1">{label}</p>
            <p className="text-3xl font-extrabold text-gray-900">{value}</p>
          </div>
          <div className={`w-11 h-11 rounded-xl ${bg} flex items-center justify-center shrink-0`}>
            <Icon className={`w-5 h-5 ${color}`} />
          </div>
        </div>
      ))}
    </div>
  );
}